module.exports = __webpack_public_path__ + "img/y-210.9be2b74a.png";